import React from 'react';

import SquareRadioButton, {SquareRadioButtonProps} from 'components/SquareRadioButton';

interface Props extends Omit<SquareRadioButtonProps, 'onSelect' | 'selectedOption'> {
  value: boolean | undefined;
  onToggle: (checked: boolean) => void;
  width?: number;
}

/**
 * Wraps a Square Radio Button with a checkbox-like interface
 */
export default class SquareToggleButton extends React.PureComponent<Props> {
  render() {
    const {width, icon, text, value, onToggle, textPosition, vertical} = this.props;
    return (
      <SquareRadioButton
        value={true}
        selectedOption={value}
        icon={icon}
        text={text}
        onSelect={onToggle}
        textPosition={textPosition}
        width={width}
        vertical={vertical}
      />
    );
  }
}
